import { customerPortal } from "@vilocnv/allsetra-core";
import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getGeozoneAssignedObjectsAction } from "../actions/get-geozone-assigned-objects.action";
import { mapObjectsToMarkers } from "domain/objects/entities/mappers/map-objects-to-markers.mapper";

type GeozonesState = customerPortal.geozones.GeozonesState;

const getGeozoneAssignedObjectsCases = (
  builder: ActionReducerMapBuilder<GeozonesState>
) => {
  builder.addCase(getGeozoneAssignedObjectsAction.pending, (state) => {
    state.isLoadingGeozoneAssignedObjects = true;
  });
  builder.addCase(
    getGeozoneAssignedObjectsAction.fulfilled,
    (state, action) => {
      state.geozoneAssignedObjects = action.payload;
      state.geozoneAssignedObjectsMarkers = mapObjectsToMarkers(action.payload);
      state.isLoadingGeozoneAssignedObjects = false;
    }
  );
  builder.addCase(getGeozoneAssignedObjectsAction.rejected, (state) => {
    state.isLoadingGeozoneAssignedObjects = false;
  });
};

export default getGeozoneAssignedObjectsCases;
